<div class="flex min-h-screen flex-col">
  <app-header />
  <div class="h-[48px]"></div>

  <div class="bg-surface-subtle flex flex-1 gap-2">
    @if (showSidebar()) {
      <app-user-sidebar
        [class.collapsed]="isSidebarCollapsed"
        class="transition-width sticky top-[48px] z-40 flex max-h-[calc(100vh_-_48px)] w-[220px] shrink-0 flex-col gap-3 self-start overflow-y-auto bg-white px-[12px] py-[12px] shadow-[2px_0_5px_rgba(0,0,0,0.15)] duration-100"
        (sidebarToggle)="onSidebarToggle()" />
    }

    @if (showSidebar() && isSidebarCollapsed) {
      <button (click)="onSidebarToggle()" class="open-btn fixed top-[68px] z-40 ltr:left-2 rtl:right-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M4 18q-.425 0-.712-.288T3 17t.288-.712T4 16h16q.425 0 .713.288T21 17t-.288.713T20 18zm0-5q-.425 0-.712-.288T3 12t.288-.712T4 11h16q.425 0 .713.288T21 12t-.288.713T20 13zm0-5q-.425 0-.712-.288T3 7t.288-.712T4 6h16q.425 0 .713.288T21 7t-.288.713T20 8z" />
        </svg>
      </button>
    }

    <div class="flex min-w-0 flex-1 flex-col gap-3">
      <div class="mt-4 flex min-w-0 flex-1 flex-col gap-1 p-2">
        <app-page-header
          [class.ltr:ml-11]="isSidebarCollapsed"
          [class.rtl:mr-11]="isSidebarCollapsed"
          [class.mt-3]="isSidebarCollapsed"
          [breadcrumbs]="breadcrumbs"
          [pageTitle]="currentPageTitle"
          [pageTitleUrl]="currentPageUrl"
          [showActions]="false"
          [showTitle]="false" />
        <router-outlet />
      </div>
    </div>
  </div>

  <app-footer />
</div>
